/**
 * Component for UnsupportedBrowser
 *
 * @module components/UnsupportedBrowser
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonLink, { ButtonLinkStyles } from '../../../../components/ButtonLink';
import MiniHeader from '../../MiniHeader/MiniHeader';

import './UnsupportedBrowserBar.scss';

class UnsupportedBrowserBar extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    unsupportedBrowserUrl: PropTypes.string,
    messageString: PropTypes.string,
    buttonUrl: PropTypes.string,
    buttonString: PropTypes.string,
  };

  render() {
    let BlueBarLink;
    if (this.props.buttonUrl) {
      // saga passes url for ie11 browsers
      BlueBarLink = (
        <a className={'BlueBar__link BlueBar__link__text'} href={this.props.buttonUrl}>
          <FormattedMessage {...this.props.buttonString} />
        </a>
      );
    } else {
      BlueBarLink = (
        <ButtonLink
          externalLink={true}
          styleNames={[ButtonLinkStyles.NAV_BLUEBAR, ButtonLinkStyles.NAV]}
          to={this.props.unsupportedBrowserUrl}
          title={this.props.buttonString}
        />
      );
    }

    return (
      <MiniHeader showing={true} onClose={this.props.onClose}>
        <div className='UnsupportedBrowserBar'>
          <FormattedMessage {...this.props.messageString} />
          {BlueBarLink}
        </div>
      </MiniHeader>
    );
  }
}

export default UnsupportedBrowserBar;
